export enum PAYMENT_METHODS {
    BANK_DEPOSIT = 4,
    GALICIA_INTEGRATED_COLLECTION = 8,
    ELECTRONIC_CHECK = 5,
    TAX_WITHHOLDING = 6,
    ROUNDING = 3,
  }